import ApiService from '@/services/api.service'
import type { ReorderStageItem } from '@/types/pipeline'

export default {
  getStages: () =>
    ApiService().get('/user/pipeline/stages'),

  addStage: (name: string) =>
    ApiService().post('/user/pipeline/stages', { name }),

  updateStage: (id: number, name: string) =>
    ApiService().patch(`/user/pipeline/stages/${id}`, { name }),

  deleteStage: (id: number) =>
    ApiService().delete(`/user/pipeline/stages/${id}`),

  reorderStages: (stages: ReorderStageItem[]) =>
    ApiService().patch('/user/pipeline/stages/reorder', { stages }),

  getBoard: () =>
    ApiService().get('/user/pipeline/leads'),

  moveCard: (leadId: number, pipelineStageId: number) =>
    ApiService().patch(`/user/pipeline/leads/${leadId}/move`, {
      pipeline_stage_id: pipelineStageId
    }),

  removeCard: (leadId: number) =>
    ApiService().patch(`/user/pipeline/leads/${leadId}/remove`),

  updateCard: (leadId: number, data: Record<string, any>) =>
  ApiService().put(`/user/pipeline/leads/${leadId}/card`, data),
}